const DEFAULT_SCRIPT_COVER = import.meta.env.VITE_DEFAULT_SCRIPT_COVER;
const DEFAULT_AVATAR = import.meta.env.VITE_DEFAULT_AVATAR;
const STATIC_URL = import.meta.env.VITE_STATIC_URL;

/**
 * 获取图片完整 URL
 * @param url 图片相对路径
 * @param fallback 备用图片路径，默认使用全局配置的默认脚本封面
 * @returns 完整的图片 URL
 */
export function getImageUrl(url?: string | null, fallback: string = DEFAULT_SCRIPT_COVER): string {
  // 如果 URL 不存在或为空，返回默认图片
  if (!url) {
    return fallback.startsWith('http') ? fallback : (window.location.origin + fallback);
  }

  // 如果已经是完整 URL（以 http 开头），直接返回
  if (url.startsWith('http')) {
    return url;
  }

  // 否则拼接静态资源前缀
  return `${STATIC_URL}${url.startsWith('/') ? url.slice(1) : url}`;
}

/**
 * 获取脚本封面图
 * @param coverPath 封面图路径
 * @returns 完整的封面图 URL
 */
export function getScriptCover(coverPath?: string | null): string {
  return getImageUrl(coverPath, DEFAULT_SCRIPT_COVER);
} 
